<template>
  <div>
    <div v-for="item in items" v-bind:key="item.QUESTION_PK">
      {{ item.QUESTION_PK }}
      <b-form-radio-group v-model="value" :options="level" :state="state" name="radio-validation">
        <b-form-invalid-feedback :state="state">Please select one</b-form-invalid-feedback>
        <b-form-valid-feedback :state="state">Thank you</b-form-valid-feedback>
      </b-form-radio-group>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
export default {
  data() {
    return {
      value: [],
      student: {},
      radio: [],
      std_id: "",
      qn_year: "",
      question_id: "",
      ans: "",
      suggestion: "",
      level: [
        { text: "น้อย", value: "1" },
        { text: "ปานกลาง", value: "2" },
        { text: "มาก", value: "3" },
        { text: "มากที่สุด", value: 4 }
      ],
      items: []
    };
  },
  computed: {
    state() {
      return Boolean(this.value);
    }
  },
  methods: {
    getQuestionnaire(questionnaireid, thaistudent) {
      api
        .getQuestionByQuestionnaireID(questionnaireid, thaistudent)
        .then(res => {
          this.items = res.data.data;
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    }
  },
  created() {
    // var string = "foo",
    //   substring = "oo";
    this.getQuestionnaire(2, 1);
    // console.log(string.includes(substring));
  }
};
</script>
